import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { fieldPropTypes } from "redux-form/immutable"

import { regionFieldConnection } from "forms/selectors"
import { getCustomRegions } from "forms/action-creators"
import { hasAnyPermission, regionsFromDataTypePermission, hasAllPermissions } from "shared/imports/permissionFunctions"
import SelectField from "forms/components/SelectField"

import { isRegionEnabled } from "shared/region-selection/helperFunctions"

import "app/static/stylus/FormStyles.styl"

class RegionField extends Component {
    componentDidMount() {
        this.props.getCustomRegions()
    }

    render() {
        const { PermissionType, SupportedRegion, Region } = DjangIO.app.models

        let supportedRegions = []

        const hasFederalPermission = hasAnyPermission(PermissionType.federal)
        const hasStatePermission = hasAnyPermission(PermissionType.states)

        // Start Regions array with 'All Regions', 'All Regions' should always be the first option
        if (hasFederalPermission && hasStatePermission) {
            supportedRegions.push(SupportedRegion.all_regions)
        }

        // Check for each overall SupportedRegion and add to regions
        if (hasFederalPermission) {
            supportedRegions.push(Region.federal)
        }

        if (hasStatePermission) {
            supportedRegions.push(SupportedRegion.states)
        }

        if (hasAnyPermission(PermissionType.local)) {
            supportedRegions.push(SupportedRegion.local)
        }

        if (
            this.props.dataType === DjangIO.app.models.QuorumDataType.dashboard &&
            hasAllPermissions(PermissionType.local, PermissionType.states)
        ) {
            supportedRegions.push(SupportedRegion.states_and_local)
        }

        supportedRegions = supportedRegions.map((region) => ({
            value: region.value,
            label: region.region_name,
        }))

        const customRegions = this.props.customRegions.map((customRegion) => ({
            value: DjangIO.app.userdata.models.CustomRegionSelection.foreignKey(customRegion.id),
            label: customRegion.name,
        }))

        const regionsPermissionedForDataType = regionsFromDataTypePermission(this.props.dataType)

        const regions = Region.items()
            .filter((item) => regionsPermissionedForDataType.includes(item.value))
            // Prevent a second Federal region to appear in the list
            // Filter for allowed regions
            .filter((item) => item !== Region.federal && isRegionEnabled(item))
            .sort((a, b) => a.order - b.order)
            .map((region) => ({
                value: region.value,
                label: region.region_name,
            }))

        const allRegions = supportedRegions.concat(customRegions).concat(regions)

        if (allRegions.length === 2 && allRegions[0] === SupportedRegion.all_regions) {
            // If there are only 2 regions in allRegions and the first is 'All Regions'
            // then the second is the only region they have access to.
            // Therefore, we should remove the 'All Regions' option since it is redundant.
            allRegions.shift()
        }

        return (
            // No need to show this control when there is only one option.
            allRegions.length > 1 && (
                <SelectField
                    choices={this.props.isLoading ? [] : allRegions}
                    label="Region"
                    defaultLabel="Choose a Region"
                    noResultsText={this.props.isLoading ? "Loading Custom Regions..." : "No results found"}
                    toolTipText={this.props.toolTipText}
                    shouldNotShowClearButton
                    {...this.props}
                />
            )
        )
    }
}

RegionField.propTypes = {
    label: PropTypes.string,

    customRegions: PropTypes.array.isRequired,
    dataType: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    getCustomRegions: PropTypes.func.isRequired,

    ...fieldPropTypes,
}

export default connect(regionFieldConnection, { getCustomRegions })(RegionField)
